import React from 'react';
import { 
  Upload, 
  FileText, 
  Send, 
  BarChart3, 
  Users, 
  Bot,
  Globe2,
  PlusCircle
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: Bot,
      title: 'AI Content Creator',
      description: 'Generate PR content with AI',
      color: 'bg-purple-500',
      path: '/ai-content-creator'
    },
    {
      icon: Upload,
      title: 'PR Distribution',
      description: 'Upload and distribute releases',
      color: 'bg-blue-500',
      path: '/pr-distribution'
    },
    {
      icon: FileText,
      title: 'Press Kit Builder',
      description: 'Create digital press kits',
      color: 'bg-green-500',
      path: '/press-kit-builder'
    },
    {
      icon: Send,
      title: 'Email Campaigns',
      description: 'Manage outreach campaigns',
      color: 'bg-orange-500',
      path: '/email-campaign-manager'
    },
    {
      icon: Users,
      title: 'Media Contacts',
      description: 'Manage journalist database',
      color: 'bg-indigo-500',
      path: '/media-contacts'
    },
    {
      icon: BarChart3,
      title: 'Analytics',
      description: 'View campaign performance',
      color: 'bg-teal-500',
      path: '/analytics-dashboard'
    }
  ];

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Quick Actions</h2>
        <button className="text-sm text-muted-foreground hover:text-foreground transition">
          <PlusCircle size={16} />
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {actions?.map((action, index) => {
          const IconComponent = action?.icon;
          return (
            <button
              key={index}
              onClick={() => handleActionClick(action?.path)}
              className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg hover:bg-muted transition-colors group"
            >
              <div className={`h-8 w-8 rounded-lg ${action?.color} text-white flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <IconComponent size={16} />
              </div>
              <div className="text-left">
                <p className="text-sm font-medium text-foreground">{action?.title}</p>
                <p className="text-xs text-muted-foreground">{action?.description}</p>
              </div>
            </button>
          );
        })}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <button 
          onClick={() => handleActionClick('/pr-distribution')}
          className="w-full flex items-center justify-center gap-2 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition"
        >
          <Globe2 size={16} />
          <span className="text-sm font-medium">New PR Campaign</span>
        </button>
      </div>
    </div>
  );
};

export default QuickActions;